import { Account } from "../Account/Account";
import { SidebarFooterProps } from "./DashboardLayout";

export function SidebarFooterAccount({ mini }: SidebarFooterProps) {
  return <Account variant={mini ? "condensed" : "expanded"} />;
}
